import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import PremiumOverlay from '../premiumoverlay/premiumoverlay.component.vue';
import GuestOverlay from '../guestoverlay/guestoverlay.component.vue';
import { cameraService } from '@/services/';
import videojs, { VideoJsPlayer } from 'video.js';
import { Auth } from 'aws-amplify';
import AWS from 'aws-sdk';
import KinesisVideo from 'aws-sdk/clients/kinesisvideo';
import KinesisVideoArchivedMedia from 'aws-sdk/clients/kinesisvideoarchivedmedia';
import { Endpoint } from 'aws-sdk/lib/core';
import { Logger } from 'aws-amplify';
import axios from 'axios';
const logger = new Logger('Livestream');

const dynamoDb = new AWS.DynamoDB.DocumentClient();

// Placez cette fonction ici, avant la déclaration de la classe
async function configureAWSCredentials() {
  try {
    const credentials = await Auth.currentCredentials();
    AWS.config.update({
      credentials: credentials,
      region: 'eu-west-3', // Remplacez par votre région AWS
    });
    console.log('AWS Credentials configurés avec succès.');
  } catch (error) {
    console.error('Erreur lors de la configuration des credentials AWS:', error);
  }
}

@Component({
  components: {
    PremiumOverlay,
    GuestOverlay,
  },
})
export default class Livestream extends Vue {
  @Prop({ type: Object, required: true }) private readonly camera!: Camera;
  @Prop({ type: Object, required: true }) private readonly project!: Project;
  @Prop({ required: true }) readonly isPremium!: boolean;
  @Prop({ required: true }) readonly isGuest!: boolean;

  private visible = false;
  private cameraremaining: number | null = null;
  private timeout: null | number = null;

  private livestreamwait = false;
  private isLoading = true;
  private showplayer = false;
  private showIframe = false;
  private isLoadingPlayer = false;
  private liveStartTime: Date | null = null;
  private archivedVideos: Array<{ fileName: string; url: string }> = [];
  private isLoadingArchive = false;
  private visibleArchives = true;
  private isRecordingLive = false;

  private selectedVideoToDelete: { fileName: string; url: string } | null = null;

  private channelARN: string | null = null;

  private maxWait = 0;

  private player?: VideoJsPlayer;
  private options = {
    fluid: true,
    controls: true,
  };

  public get isPreviousCamera(): boolean {
    return this.project.camerasId.indexOf(this.camera.id) === -1;
  }

  public get computedIframeSrc(): string {
    return `https://vdo.ninja/?v=${this.camera.id}_bitrate=10000&p=0&autoplay=1&noaudio`;
  }

  private isLoadingRemaining = true;

  @Watch('camera')
  private onCameraChange(newCamera: Camera, oldCamera: Camera) {
    if (newCamera.id !== oldCamera.id) {
      this.fetchCameraRemaining(); // Récupérer les nouvelles données pour la nouvelle caméra
      this.resetDailySessions();
    }
  }

  public async mounted(): Promise<void> {
    await configureAWSCredentials();

    if (this.camera.shadow !== undefined) {
      logger.info(this.camera.shadow.desired.Camera_Mode);
      this.livestreamwait = this.camera.shadow.desired.Camera_Mode === '3';
    }

    await this.resetDailySessions(); // Réinitialiser les sessions quotidiennes si nécessaire
    await this.fetchCameraRemaining(); // Récupérer la valeur de `camera.remaining` après réinitialisation
    await this.fetchArchivedVideos();
    this.isLoading = false; // Indicateur de fin de chargement
  }

  private async fetchCameraRemaining(): Promise<void> {
    const dynamoDb = new AWS.DynamoDB.DocumentClient({
      region: 'eu-west-3',
    });

    const params = {
      TableName: 'erige-cameras-prod',
      Key: {
        id: this.camera.id,
      },
      ConsistentRead: true, // Lecture cohérente pour s'assurer que vous obtenez la dernière valeur
    };

    try {
      const result = await dynamoDb.get(params).promise();
      if (result.Item && result.Item.remaining !== undefined) {
        this.camera.remaining = result.Item.remaining;
        console.log(`1- Valeur récupérée de DynamoDB pour camera.remaining: ${this.camera.remaining}`);
      } else {
        console.error('L\'attribut "remaining" est introuvable dans l\'élément DynamoDB.');
        this.camera.remaining = 0; // Valeur par défaut si non trouvée
      }
    } catch (error) {
      console.error('Erreur lors de la récupération de camera.remaining depuis DynamoDB:', error);
      this.camera.remaining = 0; // Valeur par défaut en cas d'erreur
    }
  }

  private async resetDailySessions(): Promise<void> {
    // Obtenir la date actuelle
    const now = new Date();

    // Ajouter une heure pour ajuster au fuseau horaire de Paris
    now.setHours(now.getHours() + 2);

    // Formater la date au format 'YYYY-MM-DD'
    const today = now.toISOString().split('T')[0];
    console.log(`La date d'aujourd'hui à l'heure de Paris est: ${today}`);
    console.log(`La date d'aujourd'hui est: ${today}`);

    // Configurer explicitement la région AWS
    const dynamoDb = new AWS.DynamoDB.DocumentClient({
      region: 'eu-west-3',
    });

    const params = {
      TableName: 'erige-cameras-prod',
      Key: {
        id: this.camera.id,
      },
      UpdateExpression: 'set remaining = :r, lastReset = :lr',
      ConditionExpression: 'attribute_not_exists(lastReset) OR lastReset < :lr',
      ExpressionAttributeValues: {
        ':r': 3,
        ':lr': today,
      },
      ReturnValues: 'UPDATED_NEW',
    };

    try {
      const result = await dynamoDb.update(params).promise();
      if (result.Attributes) {
        this.camera.remaining = result.Attributes.remaining;
        console.log(`Les sessions ont été réinitialisées à 3 pour aujourd'hui (${today}).`);
      }
    } catch (error) {
      if (error.code === 'ConditionalCheckFailedException') {
        console.log("Les sessions ont déjà été réinitialisées aujourd'hui.");
      } else {
        console.error('Erreur lors de la réinitialisation des sessions:', error);
      }
    }
  }

  private beforeDestroy() {
    if (this.timeout !== null) {
      logger.info('clearTimeout');
      clearTimeout(this.timeout);
    }
  }

  private async sendSms1(phoneNumber: string, message: string): Promise<void> {
    try {
      const sns = new AWS.SNS({ region: 'eu-west-3' });
      const params = {
        Message: message,
        PhoneNumber: phoneNumber,
        MessageAttributes: {
          'AWS.MM.SMS.OriginationNumber': {
            DataType: 'String',
            StringValue: '+15482908469', // Remplacez par le numéro long que vous avez acheté
          },
        },
      };
      await sns.publish(params).promise();
      console.log('Live streaming démarré');
    } catch (error) {
      console.error('Erreur lors du déclenchement du Live', error);
    }
  }

  private async sendSms(phoneNumber: string, message: string): Promise<void> {
    try {
      const response = await axios.post(
        'https://api.brevo.com/v3/transactionalSMS/sms',
        {
          sender: 'AppTEYE', // Nom ou numéro qui apparaîtra comme expéditeur
          recipient: phoneNumber, // Numéro de téléphone du destinataire
          content: message, // Message à envoyer
        },
        {
          headers: {
            'api-key': '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', // Remplacez par votre clé API
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('SMS envoyé via Sendinblue', response.data);
    } catch (error) {
      if (error.response) {
        console.error("Erreur lors de l'envoi du SMS avec Brevo:");
        console.error('Status:', error.response.status);
        console.error('Data:', error.response.data);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {
        console.error("La requête a été envoyée mais aucune réponse n'a été reçue:", error.request);
      } else {
        console.error('Erreur lors de la configuration de la requête:', error.message);
      }
    }
  }

  public async onPlayIconClick(): Promise<void> {
    if (this.camera && this.camera.remaining! > 0) {
      // Vérifier si des sessions sont disponibles
      this.showIframe = true;
      await this.decrementSessionState();
      const message = 'Live';
      if (this.camera && this.camera.phonenumber) {
        await this.sendSms(this.camera.phonenumber, message);
      }
      this.$nextTick(() => {
        const iframe = this.$refs.videoIframe as HTMLIFrameElement;
        if (iframe) {
          iframe.onload = () => {
            iframe.contentWindow?.postMessage({ type: 'start' }, '*');
            setTimeout(() => {
              iframe.contentWindow?.postMessage({ type: 'play' }, '*');
            }, 500);
          };
        }
      });
      // Décrémenter le nombre de sessions restantes après 1 minute (60 000 ms)
      setTimeout(async () => {
        this.showIframe = false;
      }, 85000);
    } else {
      alert('Aucune session live restante.');
    }
  }

  private async decrementSessionState(): Promise<void> {
    if (this.camera && this.camera.remaining! > 0) {
      this.camera.remaining! -= 1; // Décrémenter le nombre de sessions restantes

      // Configurer explicitement la région AWS
      const dynamoDb = new AWS.DynamoDB.DocumentClient({
        region: 'eu-west-3', // Remplacez par votre région AWS
      });

      // Mettre à jour la valeur dans DynamoDB
      const params = {
        TableName: 'erige-cameras-prod', // Remplacez par votre table DynamoDB
        Key: {
          id: this.camera.id, // Clé primaire (remplacez par vos attributs de clé primaire)
        },
        UpdateExpression: 'set remaining = :r',
        ExpressionAttributeValues: {
          ':r': this.camera.remaining,
        },
        ReturnValues: 'UPDATED_NEW',
      };
      try {
        await dynamoDb.update(params).promise();
        console.log(`Sessions restantes mises à jour: ${this.camera.remaining}`);
      } catch (error) {
        console.error('Erreur lors de la mise à jour de DynamoDB:', error);
      }
    }
  }

  public async requestlivestream(): Promise<void> {
    console.log('showplayerStart:', this.showplayer);
    console.log('isLoadingPlayerStart:', this.isLoadingPlayer);
    this.isLoadingPlayer = true;
    if (this.camera.shadow === undefined) {
      return;
    }
    this.livestreamwait = this.camera.shadow.desired.Camera_Mode === '3';
    if (this.channelARN === null) {
      this.channelARN = await cameraService.requestVideoStream(this.camera.id);
    }
    const region = this.channelARN.split(':')[3];
    logger.info('', this.channelARN);
    const credentials = await Auth.currentCredentials();

    const kinesisVideoClient = new KinesisVideo({ region, credentials });
    const kinesisVideoArchivedContent = new KinesisVideoArchivedMedia({ region, credentials });
    logger.info('Fetching data endpoint');

    const dataEndpointResponse = await kinesisVideoClient
      .getDataEndpoint({
        StreamARN: this.channelARN,
        APIName: 'GET_HLS_STREAMING_SESSION_URL',
      })
      .promise();

    logger.info('Data endpoint: ' + dataEndpointResponse.DataEndpoint);
    if (dataEndpointResponse.DataEndpoint === undefined) {
      return;
    }
    kinesisVideoArchivedContent.endpoint = new Endpoint(dataEndpointResponse.DataEndpoint);

    // Step 3: Get a Streaming Session URL
    const consoleInfo = 'Fetching HLS Streaming Session URL';
    logger.info(consoleInfo);

    try {
      const hlsStreamingSessionURLResponse = await kinesisVideoArchivedContent
        .getHLSStreamingSessionURL({
          StreamARN: this.channelARN,
          PlaybackMode: 'LIVE',
          ContainerFormat: 'MPEG_TS',
          MaxMediaPlaylistFragmentResults: 5, // Nombre maximum de fragments HLS
          DiscontinuityMode: 'ALWAYS', // Gérer les discontinuités pour éviter les coupures
        })
        .promise();

      logger.info('HLS Streaming Session URL: ' + hlsStreamingSessionURLResponse.HLSStreamingSessionURL);

      if (hlsStreamingSessionURLResponse.HLSStreamingSessionURL === undefined) {
        return;
      }
      this.liveStartTime = new Date();
      this.showplayer = true;
      await this.decrementSessionState();
      await this.$nextTick();
      const videoPlayer = this.$refs.videoPlayer as Element | undefined;
      if (videoPlayer === undefined) {
        return;
      }
      this.player = videojs(videoPlayer, this.options, () => {
        logger.info('onPlayerReady', this.player);
      });
      logger.info('Created VideoJS Player');
      this.player.src({
        src: hlsStreamingSessionURLResponse.HLSStreamingSessionURL,
        type: 'application/x-mpegURL',
      });
      logger.info('Set player source');
      this.player.play();
      logger.info('Starting playback');
      setTimeout(async () => {
        logger.info('Session ended, resetting states');
        this.isLoadingPlayer = false;
        this.showplayer = false; // Réinitialiser pour afficher l’icône "play"
        this.player?.pause(); // Arrêter la lecture
        this.player?.dispose();
        this.isRecordingLive = true;
        await this.saveClipToS3();
        //window.location.reload();
      }, 60000);
      this.player.on('ended', () => {
        logger.info('Playback finished');
        this.player?.pause();
        this.showplayer = false; // Réinitialise l'état pour réafficher l'icône "play"
        this.isLoadingPlayer = false; // Désactive le loader
      });
      this.player.on('ended', async () => {
        this.showplayer = false; // Réinitialise en cas d'erreur
        this.isLoadingPlayer = false; // Désactive le loader
        await this.saveClipToS3();
      });
      this.player?.on('ready', () => {
        this.isLoadingPlayer = false; // Fin du chargement
      });

      this.livestreamwait = false;
    } catch (error) {
      if (error.code === 'ResourceNotFoundException') {
        if (this.maxWait !== 0) {
          this.maxWait = this.maxWait - 0.5;
        } else {
          this.maxWait = Number.parseInt(this.camera.shadow.reported.Photo_Interval, 10);
        }
        logger.info('retry in ', this.maxWait);
        this.timeout = window.setTimeout(() => this.requestlivestream(), Math.min(0.5, this.maxWait) * 60000);
      } else {
        logger.error(error);
      }
    }
  }

  private async saveClipToS3(): Promise<void> {
    try {
      if (!this.channelARN) {
        console.error('Impossible de récupérer un clip : channelARN manquant');
        return;
      }
      if (!this.liveStartTime) {
        console.error('Impossible de récupérer un clip : liveStartTime manquant');
        return;
      }

      const region = this.channelARN.split(':')[3];
      const credentials = await Auth.currentCredentials();

      const kinesisVideoClient = new KinesisVideo({ region, credentials });
      const kinesisVideoArchivedContent = new KinesisVideoArchivedMedia({ region, credentials });

      // 1) Récupérer l'endpoint pour GET_CLIP
      const dataEndpointResponse = await kinesisVideoClient
        .getDataEndpoint({
          StreamARN: this.channelARN,
          APIName: 'GET_CLIP',
        })
        .promise();

      if (!dataEndpointResponse.DataEndpoint) {
        console.error('DataEndpoint manquant pour GET_CLIP');
        return;
      }
      kinesisVideoArchivedContent.endpoint = new Endpoint(dataEndpointResponse.DataEndpoint);

      // 2) Définir la plage horaire (début -> fin)
      const now = new Date();
      const start = this.liveStartTime;

      // 3) Récupérer le payload MP4 (déjà un Uint8Array apparemment)
      const clipResponse = await kinesisVideoArchivedContent
        .getClip({
          StreamARN: this.channelARN,
          ClipFragmentSelector: {
            FragmentSelectorType: 'SERVER_TIMESTAMP',
            TimestampRange: {
              StartTimestamp: start,
              EndTimestamp: now,
            },
          },
        })
        .promise();

      if (!clipResponse.Payload) {
        console.error('Payload du clip vide');
        return;
      }

      // --- Ici, plus de lecture "stream" ou Buffer ---
      // Selon votre log, clipResponse.Payload est déjà un Uint8Array.
      console.log('Type de Payload :', clipResponse.Payload);
      const videoData = clipResponse.Payload as Uint8Array;

      console.log(`Taille du clip : ${videoData.length} octets`);

      // 4) Construire le chemin S3
      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const cameraID = this.camera.id;

      const fileName = this.formatTimestamp(now) + '.mp4';
      const key = `public/${ownerID}/${projectID}/${cameraID}/livevideo/${fileName}`;

      // 5) putObject dans le bucket S3 avec le Uint8Array
      const s3 = new AWS.S3({ region, credentials });
      await s3
        .putObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
          Body: videoData, // on passe directement le Uint8Array
          ContentType: 'video/mp4',
        })
        .promise();

      console.log('Clip uploadé avec succès !', key);
      window.location.reload();
    } catch (error) {
      console.error('Erreur lors de saveClipToS3:', error);
    } finally {
      this.isRecordingLive = false; // Fin de l'enregistrement
    }
  }

  private confirmDeleteVideo(video: { fileName: string; url: string }): void {
    this.selectedVideoToDelete = video;
    this.$bvModal.show('delete-confirm-modal');
  }

  private async deleteArchivedVideo(): Promise<void> {
    if (!this.selectedVideoToDelete) return;

    try {
      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const cameraID = this.camera.id;
      const key = `public/${ownerID}/${projectID}/${cameraID}/livevideo/${this.selectedVideoToDelete.fileName}`;

      await s3
        .deleteObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
        })
        .promise();

      // Rafraîchir la liste des vidéos
      await this.fetchArchivedVideos();
      this.selectedVideoToDelete = null;
    } catch (error) {
      console.error('Erreur lors de la suppression de la vidéo:', error);
      alert('Une erreur est survenue lors de la suppression de la vidéo');
    }
  }

  /**
   * Formatage de la date en YYYYMMDD-HHMMSS
   */
  private formatTimestamp(date: Date): string {
    const pad = (num: number) => num.toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());
    return `${yyyy}${MM}${dd}-${hh}${mm}${ss}`;
  }

  private formatVideoName(fileName: string): string {
    // Supprimer l'extension ".mp4"
    const baseName = fileName.replace('.mp4', '');

    // Extraire la date et l'heure
    const year = baseName.slice(0, 4);
    const month = baseName.slice(4, 6);
    const day = baseName.slice(6, 8);
    const hours = baseName.slice(9, 11);
    const minutes = baseName.slice(11, 13);

    // Reformater en "DD/MM/YYYY - HHhMM"
    return `${day}/${month}/${year} - ${hours}h${minutes}`;
  }

  private async fetchArchivedVideos(): Promise<void> {
    try {
      this.isLoadingArchive = true;

      const region = 'eu-west-3'; // Remplacez par votre région
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const cameraID = this.camera.id;

      const prefix = `public/${ownerID}/${projectID}/${cameraID}/livevideo/`;

      const response = await s3
        .listObjectsV2({
          Bucket: 'erige-main-store-prod',
          Prefix: prefix,
        })
        .promise();

      this.archivedVideos = (response.Contents || [])
        .filter((item) => item.Key && item.Key.endsWith('.mp4'))
        .map((item) => {
          const fileName = item.Key!.replace(prefix, '');
          const url = s3.getSignedUrl('getObject', {
            Bucket: 'erige-main-store-prod',
            Key: item.Key!,
            Expires: 3600,
            ResponseContentDisposition: `inline; filename="${fileName}"`,
            ResponseContentType: 'video/mp4',
          });
          return { fileName, url };
        });
    } catch (error) {
      console.error('Erreur lors de la récupération des vidéos archivées:', error);
    } finally {
      this.isLoadingArchive = false;
    }
  }

  public async downloadVideo(url: string, fileName: string): Promise<void> {
    try {
      const response: Response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Erreur HTTP ${response.status}`);
      }
      const blob: Blob = await response.blob();
      const downloadUrl: string = window.URL.createObjectURL(blob);

      const a: HTMLAnchorElement = document.createElement('a');
      a.href = downloadUrl;
      a.download = fileName; // Nom de fichier souhaité
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Erreur lors du téléchargement', error);
    }
  }
}
